import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Visualizer from "@/pages/Visualizer";
import EmbedGuide from "@/pages/EmbedGuide";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminFlakes from "@/pages/AdminFlakes";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Visualizer />} />
          <Route path="/embed" element={<Visualizer embed />} />
          <Route path="/embed-guide" element={<EmbedGuide />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/flakes" element={<AdminFlakes />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="top-center"
        toastOptions={{
          style: {
            background: "#141517",
            border: "1px solid #272a2e",
            color: "#fff",
          },
        }}
      />
    </div>
  );
}

export default App;
